const SHARE_LINKS = {
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=',
    twitter: 'https://twitter.com/share?url=',
    linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url='
};
const shareOnSocialNetwork = ({ socialNetwork, url, shareUrl })=>{
    const shareLink = socialNetwork && url ? `${SHARE_LINKS[socialNetwork]}${url}` : shareUrl;
    if (shareLink) window.open(shareLink, '_blank', 'toolbar=no, scrollbars=yes, resizable=yes, top=400, left=400, width=700, height=500');
};
const src_shareOnSocialNetwork = shareOnSocialNetwork;
export default src_shareOnSocialNetwork;
